<template>
  <div class="step-activity-layout" :class="{ 'activity-finished': activityFinished, 'activity-intro': !activityStarted && !activityFinished && isDataLoaded }">
    <div class="intro-wrapper" v-if="isDataLoaded && !activityStarted && !activityFinished">
      <slot name="intro"></slot>
    </div>
    <div v-else-if="isDataLoaded">
      <div class="head" v-if="!activityFinished">
        <slot name="head">
          {{ title }}
        </slot>
      </div>
      <div class="content-wrapper">
        <div class="content">
          <slot name="content"></slot>
        </div>
        <div class="bottom" v-if="activityFinished && showBottom">
          <slot name="bottom">
            <div class="app-decoration-block end-block">
              <p class="decoration-block-content">
                {{ $t('training.global.partFinished') }}
              </p>
              <app-button-layout @click="goToNextStep">
                {{ $t('global.navigation.resume') }}
              </app-button-layout>
              <app-button-layout color="alternate-secondary" @click="resumeLater">
                {{ $t('global.navigation.resumeLater') }}
              </app-button-layout>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButtonLayout from '@/components/buttons/AppButtonLayout'
import useTrainingUtils from '@/utils/useTrainingUtils'

export default {
  name: 'StepActivityLayout',
  components: { AppButtonLayout },
  props: {
    title: {
      type: String,
      required: false
    },
    activityFinished: {
      type: Boolean,
      required: false,
      default: false
    },
    activityStarted: {
      type: Boolean,
      required: false,
      default: false
    },
    showBottom: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup () {
    const { goToNextStep, resumeLater, isDataLoaded } = useTrainingUtils()
    return { goToNextStep, resumeLater, isDataLoaded }
  }
}
</script>

<style lang="scss" scoped>
.step-activity-layout {
  height: 100%;
  background-color: #043755;
  padding-bottom: $space-xxl;
  &.activity-finished {
    padding: $space-s $space-s $space-xxl $space-s;
  }
  .head {
    background-color: $c-primary;
    color: #fff;
    font-family: $ff-big;
    font-weight: $fw-l;
    font-size: $fz-l;
    padding: $space-m;
    text-align: center;
  }
  .content {
    max-width: $training-max-width-tablet;
    margin: 0 auto;
    padding-bottom: $space-l;
  }
  .bottom {
    max-width: $training-max-width-tablet;
    margin: 0 auto;
  }
}

@media (min-width: $bp-tablet) {
  .step-activity-layout {
    &.activity-intro {
      background-color: $c-primary;
    }
    .content-wrapper {
      max-width: $training-max-width;
      margin: 0 auto;
      .content {
        margin: 0;
        max-width: none;
      }
      .bottom {
        margin: 0;
        max-width: none;
      }
    }
    &.activity-finished {
      .content-wrapper {
        display: grid;
        gap: $space-s;
        grid-template-columns: repeat(9, 1fr);
        .content {
          grid-column-start: 2;
          grid-column-end: 6;
        }
        .bottom {
          grid-column-start: 6;
          grid-column-end: 9;
        }
      }
    }
  }
}

@media (min-width: $bp-desktop) {
  .step-activity-layout {
    .content-wrapper {
      max-width: $bp-desktop;
    }
    &.activity-finished {
      .content-wrapper {
        .content {
          grid-column-start: 2;
          grid-column-end: 6;
        }
        .bottom {
          grid-column-start: 6;
          grid-column-end: 9;
        }
      }
    }
  }
}
</style>
